export default __webpack_public_path__ + "static/media/torus.01a6e021.svg";